import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Окно «введите телефон» для гостя. Открывается из любого места (закрытый пункт меню, закрытая страница);
 * после успеха сообщает об этом и ведёт туда, куда гость шёл.
 */
@Injectable({ providedIn: 'root' })
export class PhoneClaimService {
  visible = false;
  /** Куда перейти после ввода телефона. */
  redirectTo: string | null = null;

  /** Телефон сохранён: меню и страница обновляют вид. */
  readonly claimed$ = new Subject<void>();
  readonly changed$ = new Subject<void>();

  open(redirectTo?: string): void {
    this.redirectTo = redirectTo ?? null;
    this.visible = true;
    this.changed$.next();
  }

  close(): void {
    this.visible = false;
    this.changed$.next();
  }

  complete(): void {
    this.visible = false;
    this.claimed$.next();
    this.changed$.next();
  }
}
